module.exports = __webpack_public_path__ + "img/indicate_icon_5.3615b268.png";